import FormattedMessage from 'I18n/components/FormattedMessage';
import { COLLABORATION_GENERATE_TRIGGER } from 'automation-ui-canvas/constants/Gates';
import CollabGenTriggersFlowContent from 'automation-ui-canvas/containers/flow-views/collab-gen-triggers-flow/CollabGenTriggersFlowContent';
import useGetCollabGenTriggersFlowData from 'automation-ui-canvas/containers/flow-views/collab-gen-triggers-flow/useGetCollabGenTriggersFlowData';
import { COLLAB_GEN_TRIGGERS_FLOW_VIEW } from 'automation-ui-canvas/containers/flow-views/flowViewIds';
import { jsx as _jsx } from "react/jsx-runtime";
const CollabGenTriggerFlowViewConfig = {
  id: COLLAB_GEN_TRIGGERS_FLOW_VIEW,
  getIsAvailable: ({
    getIsUngated
  }) => getIsUngated(COLLABORATION_GENERATE_TRIGGER),
  useGetViewData: useGetCollabGenTriggersFlowData,
  modeIndicator: {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.collabGenTriggersFlow.mode"
    }),
    use: 'preview'
  },
  menuBar: {
    MenuBarComponent: null
  },
  ContentComponent: CollabGenTriggersFlowContent
};
export default CollabGenTriggerFlowViewConfig;